// extracted by mini-css-extract-plugin
module.exports = {"select":"select-module--select--1aRwc"};